<template>
    <div class="flag-selector">
      <div class="header">
        <!-- <h1>下月学习Flag选择</h1> -->
         <P class="font1">逐梦前行，点亮成长</P>
         <P class="font1">开启你的季度学习FLAG！</P>
         <!-- <P class="font1">让我们坚定信念，勇敢追梦！</P> -->
      </div>
      
      <div class="goals-container">
        <div class="goal-row" v-for="(row, rowIndex) in goalRows" :key="rowIndex">
          <div class="goal-wrapper" :style="getAnimationStyle(rowIndex)">
            <div class="goal" v-for="(goal, index) in row.goals" :key="`${rowIndex}-${index}`" :data-id="goal.id" :class="{ selected: isSelected(goal.id) }" @click="toggleGoal(goal.id)">
              <div class="goal-icon">{{ goal.emoji }}</div>
              <div class="goal-text">{{ goal.text }}</div>
              <div class="check-icon">✓</div>
            </div>
            <!-- 复制元素以实现无缝滚动 -->
            <div class="goal" v-for="(goal, index) in row.goals" :key="`${rowIndex}-${index}-copy`" :data-id="goal.id" :class="{ selected: isSelected(goal.id) }" @click="toggleGoal(goal.id)">
              <div class="goal-icon">{{ goal.emoji }}</div>
              <div class="goal-text">{{ goal.text }}</div>
              <div class="check-icon">✓</div>
            </div>
          </div>
        </div>
      </div>
      <div style="width: 94%;margin: 0 auto;margin-top: 30px;text-align: center;">
        <p>想知道哪些超棒的培训课程？</p>
        <p>留下邮箱，每月帮你推送线下和直播课程！</p>
        <input type="email" v-model="email" placeholder="📧请输入您的企业邮箱" style="width: 80%; padding: 10px; margin-top: 10px; border-radius: 5px; border: 1px solid #ccc;">
      </div>
      <div class="footer">
        <button class="confirm-btn" :disabled="selectedGoals.length === 0" @click="confirmSelection">确认选择</button>
      </div>
    </div>
</template>
  
<script>
export default {
    name: 'FlagSelector',
    data() {
        return {
            selectedGoals: [],
            goalRows: [
                {
                    goals: [
                        { id: '1', emoji: '💡', text: '打破思维定式，发现无限可能！' },
                        { id: '2', emoji: '🎤', text: '自信开口，让观点有力量' },
                        { id: '3', emoji: '🤝', text: '高效协作，凝聚共赢力量！' },
                    ]
                },
                {
                    goals: [
                        { id: '4', emoji: '🌟', text: '领导从心开始，影响力自然流动！' },
                        { id: '5', emoji: '🤖', text: '让AI为你加速，不为你添负担！' },
                        { id: '6', emoji: '📱', text: '善用资讯，提升判断与思辨力！' }
                    ]
                },
                {
                    goals: [
                        { id: '7', emoji: '📅', text: '精准规划，按时高质交付！' },
                        { id: '8', emoji: '📈', text: '说到做到，行动见真章！' },
                        { id: '9', emoji: '🏭', text: '消除浪费，提升效率，从源头开始！' },
                    ]
                },
                {
                    goals: [
                        { id: '10', emoji: '🔍', text: '零缺陷不是口号，是系统能力的体现！' },
                        { id: '11', emoji: '🛠️', text: '人人参与保养，设备稳定高效！' },
                        { id: '12', emoji: '🔧', text: '预防胜于修复，让停机变最少！' },
                        { id: '13', emoji: '🦺', text: '安全无小事，人人要当责！' },
                    ]
                },
            ],
            email: '' // 用于存储用户输入的邮箱
        }
    },
    methods: {
        toggleGoal(goalId) {
            const index = this.selectedGoals.indexOf(goalId);
            
            
            if (index === -1 && this.selectedGoals.length < 3) {
                this.selectedGoals.push(goalId);
            } else if (index !== -1) {
                this.selectedGoals.splice(index, 1);
            } else {
                alert('最多可选3个目标哦！');
            }
        },
        isSelected(goalId) {
            return this.selectedGoals.includes(goalId);
        },
        confirmSelection() {
            if (this.selectedGoals.length === 0) {
                this.$message({
                    message: '请至少选择一个目标！',
                    type: 'warning',
                    center: true
                })
                return;
            }

            // 获取选择的目标文本
            const selectedGoalTexts = this.selectedGoals.map(goalId => {
                for (const row of this.goalRows) {
                    const foundGoal = row.goals.find(goal => goal.id === goalId);
                    if (foundGoal) return foundGoal.text;
                }
                return null;
            }).filter(text => text !== null); // 过滤掉 null，确保数据干净

            const view = {
                comment: selectedGoalTexts.join(', '),
                email: this.email
            }
            this.$emit('confirmSelection',view)
            // console.log(selectedGoalTexts);
            // alert('目标提交成功！你选择了：' + selectedGoalTexts.join(', '));
        },
        getAnimationStyle(rowIndex) {
            // 为每行设置不同的动画延迟
            const delay = rowIndex * 1000;
            return {
                animationDelay: `${delay}ms`
            };
        }
    }
}
</script>
  
<style scoped>
.flag-selector {
    background: 
                url("../../assets/25July/logo.png") right  top  no-repeat,
                url("../../assets/25July/bg.jpg")  no-repeat;
    background-size: 100% 100%,cover;
    width: 100%;
    height: 100vh;
    padding-top: 1px;
}
  
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: Arial, sans-serif;
}
  
.header {
    text-align: center;
    margin-top: 8vh;
    margin-bottom: 2vh;
}

.font1 {
    width: 96%;
    margin: 0 auto;
    font-size: 20px;
    text-align: center·;
    color: #7126d3;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}

.header h1 {
    font-size: 19px;
    color: #333;
}

.goals-container {
    max-width: 600px;
    margin: 0 auto;
}

.goal-row {
    display: flex;
    justify-content: center;
    margin-bottom: 15px;
    overflow: hidden;
    position: relative;
    height: 40px;
}

.goal-wrapper {
    display: flex;
    animation: scrollGoals 30s linear infinite;
    animation-fill-mode: forwards;; 
}

.goal {
    background-color: #fff;
    border-radius: 20px;
    padding: 8px 15px;
    margin: 0 5px;
    display: flex;
    align-items: center;
    cursor: pointer;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
    transition: all 0.2s;
    /* min-width: 120px; */
}
  
.goal:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}
  
.goal.selected {
    background-color: #e6f7ff;
    color: #1890ff;
}
  
.goal-icon {
    margin-right: 8px;
    font-size: 19px;
}

.goal-text {
    flex: 1;
    font-size: 1rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
  
.check-icon {
    display: none;
    margin-left: 8px;
    font-size: 16px;
}

.goal.selected .check-icon {
    display: block;
}
  
.footer {
    text-align: center;
    margin-top: 20px;
}
  
.confirm-btn {
    background-color: #1890ff;
    color: white;
    border: none;
    border-radius: 20px;
    padding: 10px 25px;
    font-size: 16px;
    cursor: pointer;
}
  
.confirm-btn:disabled {
    background-color: #bbb;
    cursor: not-allowed;
}
  
@keyframes scrollGoals {
    0% {
        transform: translateX(50%);
    }
    100% {
        transform: translateX(-50%);
    }
}

@media screen and (min-width: 786px) {
    .flag-selector {
        background: 
                    url("../../assets/25July/pcbg.jpg")  no-repeat;
        background-size:cover;
        width: 100%;
        height: 100vh;
    }
    .goals-container {
        max-width:90vw;
        margin: 0 auto;
    }

}
</style>